import {
  fetchUserMe,
  updateUserBio,
  updateUserDob,
  updateUserFirstName,
  updateUserLastName,
  updateUserProfilePicUrl,
} from "@/ServerActions/user";
import { ApiResponse, UserRes } from "@/types";
import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";

export const useFetchUser = (enable: boolean) => {
  return useQuery<ApiResponse<UserRes>>({
    queryKey: ["user-me", "DotAdmin"], // ✅ FIXED
    queryFn: () => fetchUserMe(),
    enabled: enable,
  });
};

export const useUpdateUserFirstName = () => {
  const queryClient: any = useQueryClient();
  return useMutation({
    mutationFn: updateUserFirstName,
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: ["user-me", "DotAdmin"],
      });
    },
    onError: (error) => {
      console.log(error);
    },
  });
};

export const useUpdateUserLastName = () => {
  const queryClient: any = useQueryClient();
  return useMutation({
    mutationFn: updateUserLastName,
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: ["user-me", "DotAdmin"],
      });
    },
    onError: (error) => {
      console.log(error);
    },
  });
};

export const useUpdateUserDob = () => {
  const queryClient: any = useQueryClient();
  return useMutation({
    mutationFn: updateUserDob,
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: ["user-me", "DotAdmin"],
      });
    },
    onError: (error) => {
      console.log(error);
    },
  });
};

export const useUpdateUserBio = () => {
  const queryClient: any = useQueryClient();
  return useMutation({
    mutationFn: updateUserBio,
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: ["user-me", "DotAdmin"],
      });
    },
    onError: (error) => {
      console.log(error);
    },
  });
};

export const useUpdateUserProfilePic = () => {
  const queryClient: any = useQueryClient();
  return useMutation({
    mutationFn: updateUserProfilePicUrl,
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: ["user-me", "DotAdmin"],
      });
    },
    onError: (error) => {
      console.log(error);
    },
  });
};
